import MetaBusinessSVG from "../../../../svgs/pricing/MetaBusinessSVG";
import MetaPlusSVG from "../../../../svgs/pricing/MetaPlusSVG";
import MetaPremiumSVG from "../../../../svgs/pricing/MetaPremiumSVG";
import PricingFeaturesDataList from "../../../../data/PricingFeaturesDataList";
import CheckPlusSVG from "../../../../svgs/pricing/CheckPlusSVG";
import CheckPremiumSVG from "../../../../svgs/pricing/CheckPremiumSVG";
import CheckBusinessSVG from "../../../../svgs/pricing/CheckBusinessSVG";

const Features = () => {
  return (
    <div className="w-full border-t border-subColor4 my-4">
      <div className="flex items-center px-4 h-[80px] border-b border-subColor4">
        <div className="w-[31%] h-full flex items-center gap-2 lg:text-[20px] font-semibold text-left pl-5 text-white">
          Features
        </div>
        <div className="w-[23%] h-full flex items-center justify-center bg-[#050505]">
          <div className="w-full h-full flex items-center justify-center gap-2 lg:text-[18px] font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#A69EFF] to-[#DFDCFF]">
            <MetaPlusSVG /> Meta Plus
          </div>
        </div>
        <div className="w-[23%] h-full flex items-center justify-center gap-2 lg:text-[18px] font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#FF96F9] to-[#FFE9FE]">
          <MetaPremiumSVG /> Meta Premium
        </div>
        <div className="w-[23%] h-full flex items-center justify-center bg-[#050505]">
          <div className="w-full h-full flex items-center justify-center gap-2 lg:text-[18px] font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#00BAE2] to-[#F0FCFF]">
            <MetaBusinessSVG /> Meta Business
          </div>
        </div>
      </div>
      {PricingFeaturesDataList.map((item, index) => (
        <div className="w-full flex items-center h-[72px] border-b border-subColor4" key={index}>
          <div className="w-[31%] flex items-center gap-2 text-left pl-9 text-white h-full border-r border-subColor4">
            {item.title}
          </div>
          <div className="w-[23%] h-full flex items-center justify-center bg-[#050505] border-r border-subColor4">
            {item.metaPlus ? <CheckPlusSVG /> : ""}
          </div>
          <div className="w-[23%] h-full flex items-center justify-center border-r border-subColor4">
            {item.metaPremium ? <CheckPremiumSVG /> : ""}
          </div>
          <div className="w-[23%] h-full flex items-center justify-center bg-[#050505]">
            {item.metaBusiness ? <CheckBusinessSVG /> : ""}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Features;
